  import React from 'react';
import { Link } from 'react-router-dom';
import { MdFindInPage, MdOutlineWhatsapp, MdCheckCircle, MdOutlineHealthAndSafety, MdOutlineVerifiedUser, MdOutlineDomainVerification } from 'react-icons/md';
import { GiReceiveMoney, GiGears, GiBrazil  } from "react-icons/gi";
import { BsGraphUpArrow , BsBank2, BsCashCoin  } from "react-icons/bs";
import { CiLinkedin } from "react-icons/ci";
import styles from "./Complementares.module.css";
import imgJr from "./img/imgJr.jpeg";
import img1 from "./img/img1.png";
import img2 from "./img/img2.png";
import img3 from "./img/img3.png";
import img4 from "./img/img4.png";

function ServicosComplementares() {
  return (
    <div className={styles.paginaGestao}>   
      <section className={styles.bannerGestao}>
        <div className={styles.bannerOverlay}>
          <div className={styles.bannerConteudo}>
            <h1>Soluções Complementares</h1>
            <p>Um ecossistema abrangente de serviços desenvolvido para otimizar processos operacionais, salvaguardar o patrimônio corporativo e viabilizar a expansão sustentável da sua organização.</p>
            <Link to="/contato" className={`${styles.btnLink} ${styles.btnCyan}`}>Entre em Contato</Link>
          </div>
        </div>
      </section>
      <section className={`${styles.secaoGestao} ${styles.bgBranco}`}>
        <div className={`${styles.containerGrid} ${styles.containerGridJr}`}>
          <div>
            <div className={styles.imagemJr}>
              <img 
                src={imgJr} 
                alt="Consultoria e planejamento para MEI" 
                className={styles.imagemEspaco} 
              />
            </div>
            <h2 className={`${styles.tituloSecao} ${styles.tituloSecaoJr}`}>Organize as finanças da sua empresa e tenha mais previsibilidade no caixa</h2>
            <h3 className={`${styles.subtituloAzul} ${styles.subtituloJr}`}>BPO financeiro para pequenas e médias empresas, experiência executiva em Tesouraria, Gestão Financeira e Capital de Giro.</h3>
          </div>

          <div className={styles.textos}>
            <h2 className={`${styles.tituloSecao} ${styles.tituloSecaoJrServicos}`}>Serviços</h2>
            {/* <h3 className={styles.subtituloAzul}>Estruturação e Expansão de Negócios</h3> */}
            {/* <p>Disponibilizamos assessoria técnica especializada para Microempreendedores Individuais (MEIs) que buscam a profissionalização da gestão e a estruturação de bases sólidas para um crescimento escalável.</p> */}
            
            <ul className={styles.listaCheck}>
              <li>
                <GiReceiveMoney  className={styles.iconeCheck} />
                <span><strong>Contas a pagar e receber</strong></span>
              </li>
              <li>
                <BsGraphUpArrow  className={styles.iconeCheck} />
                <span><strong>Fluxo de caixa e projeções financeiras</strong></span>
              </li>
              <li>
                <BsBank2 className={styles.iconeCheck} />
                <span><strong>Conciliação bancária</strong></span>
              </li>
              <li>
                <BsCashCoin  className={styles.iconeCheck} />
                <span><strong>Acompanhamento de recebíveis</strong></span>
              </li>
              <li>
                <MdFindInPage  className={styles.iconeCheck} />
                <span><strong>Indicadores para tomada de decisão</strong></span>
              </li>
              <li>
                <GiGears  className={styles.iconeCheck} />
                <span><strong>Organização financeira e estruturação de processos</strong></span>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section className={`${styles.secaoGestao} ${styles.secaoContatoJr} ${styles.bgBranco}`}>
        <div className={styles.containerGridContatoJr}>
            <div className={styles.contactItem}>
                <MdOutlineWhatsapp  className={styles.iconPlaceholder}/>
                <div className={styles.textContent}>
                    <span className={styles.title}>WHATSAPP</span>
                    <span className={styles.info}><a href="https://wa.link/kl8027" target="_blank" rel="noopener noreferrer" className={`${styles.contatoJr}`} aria-label="Falar pelo WhatsApp">
                    (11) 96382 - 4878</a> </span>
                </div>
            </div>
            <div className={styles.contactItem}>
                <CiLinkedin className={styles.iconPlaceholder}/>
                <div className={styles.textContent}>
                    <span className={styles.title}>LINKEDIN</span>
                    <span className={styles.info}><a href="https://www.linkedin.com/in/juliana-rassi/" target="_blank" rel="noopener noreferrer" className={`${styles.contatoJr}`} aria-label="Acessar Linkedin">JR Gestão Financeira</a></span>
                </div>
            </div>
            <div className={styles.contactItem}>
                <GiBrazil className={styles.iconPlaceholder}/>
                <div className={styles.textContent}>
                    <span className={styles.title}>ATENDIMENTO REMOTO</span>
                    <span className={styles.info}>Para todo o Brasil</span>
                </div>
            </div>
        </div>
      </section>
      <section className={`${styles.secaoGestao} ${styles.bgClaro}`}>
        <div className={styles.containerGrid}>
          
          <div className={styles.textos}>
            <h2 className={styles.tituloSecao}>Consultoria para MEI</h2>
            <h3 className={styles.subtituloAzul}>Estruturação e Expansão de Negócios</h3>
            <p>Disponibilizamos assessoria técnica especializada para Microempreendedores Individuais (MEIs) que buscam a profissionalização da gestão e a estruturação de bases sólidas para um crescimento escalável.</p>
            
            <ul className={styles.listaCheck}>
              <li>
                <MdCheckCircle className={styles.iconeCheck} />
                <span><strong>Formalização Integral:</strong> Abertura, registro e regularização completa das atividades perante os órgãos competentes.</span>
              </li>
              <li>
                <MdCheckCircle className={styles.iconeCheck} />
                <span><strong>Planejamento Estratégico:</strong> Consultoria financeira e diretrizes tributárias customizadas para o modelo de negócio.</span>
              </li>
              <li>
                <MdCheckCircle className={styles.iconeCheck} />
                <span><strong>Gestão Fiscal:</strong> Suporte técnico na emissão de documentos fiscais e no cumprimento das obrigações acessórias.</span>
              </li>
              <li>
                <MdCheckCircle className={styles.iconeCheck} />
                <span><strong>Migração de Regime:</strong> Consultoria analítica especializada para os trâmites de transição e desenquadramento tributário.</span>
              </li>
            </ul>
          </div>

          <div className={styles.imagemWrapper}>
            <img 
              src={img1} 
              alt="Consultoria e planejamento para MEI" 
              className={styles.imagemEspaco} 
            />
          </div>

        </div>
      </section>
      <section className={`${styles.secaoGestao} ${styles.bgBranco}`}>
        <div className={`${styles.containerGrid} ${styles.gridInvertido}`}>
          
          <div className={styles.imagemWrapper}>
            <img 
              src={img2} 
              alt="Projetos de engenharia e licenças de funcionamento" 
              className={styles.imagemEspaco} 
            />
          </div>

          <div className={styles.textos}>
            <h2 className={styles.tituloSecao}>Alvarás e Regularizações</h2>
            <h3 className={styles.subtituloAzul}>Conformidade Regulatória e Mitigação de Riscos</h3>
            <p>Gerenciamos a complexidade dos trâmites regulatórios para assegurar que a sua corporação opere livre de passivos, embargos ou autuações. Por meio de parcerias estratégicas, viabilizamos a obtenção rigorosa das licenças operacionais.</p>
            
            <div className={styles.gridLicencas}>
              <div className={styles.licencaItem}>
                <MdOutlineDomainVerification className={styles.iconeLicenca} />
                <span>Alvará de Funcionamento (Engenharia)</span>
              </div>
              <div className={styles.licencaItem}>
                <MdOutlineDomainVerification className={styles.iconeLicenca} />
                <span>CMVS - Cadastro Municipal de Vigilância em Saúde</span>
              </div>
              <div className={styles.licencaItem}>
                <MdOutlineDomainVerification className={styles.iconeLicenca} />
                <span>AVCB - Auto de Vistoria do Corpo de Bombeiros</span>
              </div>
              <div className={styles.licencaItem}>
                <MdOutlineDomainVerification className={styles.iconeLicenca} />
                <span>CNES e RCNES - Cadastro Nacional de Estabelecimentos de Saúde</span>
              </div>
              <div className={styles.licencaItem}>
                <MdOutlineDomainVerification className={styles.iconeLicenca} />
                <span>Licença CADAN - Cadastro de Anúncios (São Paulo/SP)</span>
              </div>
              <div className={styles.licencaItem}>
                <MdOutlineDomainVerification className={styles.iconeLicenca} />
                <span>Baixa e Cancelamento de CADAN - SP</span>
              </div>
            </div>
          </div>

        </div>
      </section>
      <section className={`${styles.secaoGestao} ${styles.bgClaro}`}>
        <div className={styles.containerGrid}>
          
          <div className={styles.textos}>
            <h2 className={styles.tituloSecao}>Saúde Ocupacional</h2>
            <h3 className={styles.subtituloAzul}>Medicina do Trabalho e Engenharia de Segurança</h3>
            <p>O capital humano constitui o alicerce operacional de qualquer organização. Para assegurar a integridade física dos colaboradores e o estrito cumprimento das Normas Regulamentadoras (NRs) do Ministério do Trabalho, adotamos uma postura rigorosamente preventiva.</p>
            <p>Através de <strong>alianças estratégicas com clínicas especializadas</strong>, coordenamos o atendimento às exigências legais atinentes a exames ocupacionais (admissionais, demissionais e periódicos) e à implementação do Programa de Controle Médico de Saúde Ocupacional (PCMSO).</p>
            <div className={styles.boxDestaque}>
              <MdOutlineHealthAndSafety className={styles.iconeDestaque} />
              <span>Prevenção de passivos trabalhistas e consolidação de um ambiente corporativo salubre e juridicamente protegido.</span>
            </div>
          </div>

          <div className={styles.imagemWrapper}>
            <img 
              src={img3}
              alt="Exames médicos e saúde ocupacional" 
              className={styles.imagemEspaco} 
            />
          </div>

        </div>
      </section>
      <section className={`${styles.secaoGestao} ${styles.bgBranco}`}>
        <div className={`${styles.containerGrid} ${styles.gridInvertido}`}>
          
          <div className={styles.imagemWrapper}>
            <img 
              src={img4} 
              alt="Consultoria e planejamento previdenciário" 
              className={styles.imagemEspaco} 
            />
          </div>

          <div className={styles.textos}>
            <h2 className={styles.tituloSecao}>Consultoria Previdenciária</h2>
            <h3 className={styles.subtituloAzul}>Assessoria Institucional e Estratégica</h3>
            <p>O planejamento previdenciário demanda alto rigor técnico em virtude das frequentes atualizações no ordenamento jurídico. Disponibilizamos assessoria especializada e analítica para a gestão do seu patrimônio de longo prazo.</p>
            <p>Nossa equipe conduz análises detalhadas do tempo de contribuição, projeções de cenários futuros, instrução de requerimentos e regularização de benefícios junto ao Instituto Nacional do Seguro Social (INSS), assegurando a efetivação e preservação dos seus direitos.</p>
            <Link to="/contato" className={`${styles.btnLink} ${styles.btnAzul}`} style={{marginTop: '1.5rem'}}>
              Agendar Consultoria Previdenciária
            </Link>
          </div>

        </div>
      </section>
      <section className={`${styles.secaoGestao} ${styles.bgClaro}`}>
        <div className={styles.containerGrid}>
          
          <div className={styles.textos}>
            <h2 className={styles.tituloSecao}>Certificado Digital</h2>
            <h3 className={styles.subtituloAzul}>Identidade Eletrônica e Autenticidade Jurídica</h3>
            <p>A governança corporativa contemporânea exige máxima segurança nas transações eletrônicas. O Certificado Digital atua como a identidade eletrônica da corporação, sendo imprescindível para a assinatura de documentos com validade jurídica e para o acesso autenticado a plataformas governamentais, como e-CAC e eSocial.</p>
            <p>Conduzimos os processos de emissão e renovação com celeridade e sob rigorosos padrões de segurança da informação, evitando interrupções operacionais decorrentes de pendências de certificação.</p>
          </div>

          <div className={styles.certificadoCardWrapper}>
            <div className={styles.certificadoCard}>
              <MdOutlineVerifiedUser className={styles.iconeCertificado} />
              <h4>Emissão Segura e Certificada</h4>
              <p>Validação biométrica e documental presencial ou via videoconferência. Implementação de soluções em e-CPF e e-CNPJ (formatos A1 e A3), devidamente dimensionadas para atender às demandas transacionais da organização.</p>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}

export default ServicosComplementares;